import { Link } from "react-router-dom";
import Table from "../../components/table/Table";
import "./reports.scss";

const columns = [
  {
    field: "title",
    headerName: "عنوان العملية",
    width: 250,
    renderCell: (params) => (
      <>
        <img className="avatar" src={params.row.img} alt="avatar" />
        <p className="title">{params.row.title}</p>
      </>
    ),
  },
  { field: "name", headerName: "اسم الطفل", width: 150 },
  { field: "date", headerName: "تاريخ الإضافة", width: 130 },
  {
    field: "status",
    headerName: "الحالة",
    width: 165,
    renderCell: (params) => (
      <p
        className="status"
        style={{
          background:
            params.row.status === "في انتظار تدخل الأدمن"
              ? "red"
              : params.row.status === "تم التوصل إلى نتيجة"
              ? "green"
              : "lightgray",
        }}
      >
        {params.row.status}
      </p>
    ),
  },
  {
    field: "actions",
    headerName: "أزرار",
    width: 250,
    renderCell: (params) => (
      <>
        <Link to={`status/${params.row.id}r`} className="btn">
          متباعة الحالة
        </Link>
        <Link to={`result/${params.row.id}r`} className="btn">
          انظر النتيجة
        </Link>
      </>
    ),
  },
];

export default function Reports({ rows }) {
  return (
    <div className="reports">
      <Table rows={rows} columns={columns} />
    </div>
  );
}
